import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { product } from '../data/ebook';
import { bonuses, ctaOptions } from '../data/bonuses';
import { BuyButton, PRICE_ANCHOR_ID } from './BuyButton';
import { Section } from './Section';
type OfferProps = {
  ctaVariant: keyof typeof ctaOptions;
};
export function Offer({
  ctaVariant
}: OfferProps) {
  const cta = ctaOptions[ctaVariant];
  const bonusTotal = bonuses.reduce((sum, bonus) => sum + bonus.value, 0);
  const guideValue = Number(product.guideValue);
  const total = guideValue + bonusTotal;
  const savings = (total - Number(product.price)).toFixed(2);
  return <Section id="comprar" className="bg-sage-dark text-white" data-id="element-168" data-mp="13xsq235fxnbg">
      <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20" data-id="element-169" data-mp="yy7orm2st2vk">
        <div data-id="element-170" data-mp="z0aqv4h86mgn">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sage-light" data-id="element-171" data-mp="2fc698up91el5">
            La oferta de lanzamiento
          </p>
          <h2 className="mt-5 font-display text-4xl font-light leading-tight sm:text-5xl" data-id="element-172" data-mp="2acbj4tdast15">
            El próximo lunes ese jean te queda flojo otra vez.
          </h2>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-sage-light" data-id="element-173" data-mp="uishbogkrazh">
            La guía completa y los 3 bonos, todo junto. Empieza el Día de Reinicio mañana por la
            mañana.
          </p>

          <table className="mt-10 w-full text-left text-[15px]" data-id="element-174" data-mp="13k9twwurwujf">
            <caption className="sr-only" data-id="element-175" data-mp="6tppxow523rs">Valor de lo que recibes</caption>
            <thead data-id="element-176" data-mp="6vkah23hztvc">
              <tr className="border-b border-white/20 text-xs uppercase tracking-[0.16em] text-sage-light" data-id="element-177" data-mp="6rwhq55vnbho">
                <th scope="col" className="pb-3 font-semibold" data-id="element-178" data-mp="fufjsn1u9k2v">
                  Lo que recibes
                </th>
                <th scope="col" className="pb-3 text-right font-semibold" data-id="element-179" data-mp="klnurnithdi5">
                  Valor
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/10" data-id="element-180" data-mp="3k6jbqcfhwdyw">
              <tr data-id="element-181" data-mp="3o95xpwphj4o6">
                <td className="py-3.5 font-medium text-white" data-id="element-182" data-mp="3o8o65ddrpeml">{product.title} (guía de 7 días)</td>
                <td className="py-3.5 text-right tabular-nums text-white/80" data-id="element-183" data-mp="ve63ofsftzvx">${guideValue}</td>
              </tr>
              {bonuses.map(bonus => <tr key={bonus.number} data-id="element-184" data-mp="15620zomp9lz3">
                  <td className="py-3.5 text-white/90" data-id="element-185" data-mp="1550pxk5oozhd">
                    <span className="text-sage-light" data-id="element-186" data-mp="105xijt28eh68">Bono #{bonus.number} · </span>
                    {bonus.shortTitle}
                  </td>
                  <td className="py-3.5 text-right tabular-nums text-white/80" data-id="element-187" data-mp="cheke6cwbkrv">${bonus.value}</td>
                </tr>)}
            </tbody>
            <tfoot data-id="element-188" data-mp="li2p2ageg8s3">
              <tr className="border-t border-white/30" data-id="element-189" data-mp="lim7ds9yoz6n">
                <th scope="row" className="pt-4 font-semibold text-white" data-id="element-190" data-mp="hfzbnga66u46">
                  Valor total
                </th>
                <td className="pt-4 text-right font-semibold tabular-nums text-white line-through decoration-white/50" data-id="element-191" data-mp="1ww6r83x55388">
                  ${total}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div id={PRICE_ANCHOR_ID} className="flex scroll-mt-24 flex-col justify-center rounded-lg bg-white p-8 text-ink sm:p-10" data-id="element-192" data-mp="20d2nuoshg3r0">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-193" data-mp="1qgzkjflw9z2h">
            Hoy · Todo junto
          </p>
          <div className="mt-4 flex items-baseline gap-3" data-id="element-194" data-mp="1vgc862klba64">
            <span className="font-display text-6xl leading-none text-ink" data-id="element-195" data-mp="2j5f0q5grinfe">${product.price}</span>
            <span className="text-lg text-muted line-through" data-id="element-196" data-mp="2o3yl41fpjr5n">${total}</span>
          </div>
          <p className="mt-3 inline-flex self-start rounded-full bg-sage-light px-3 py-1 text-sm font-semibold text-sage-dark" data-id="element-197" data-mp="29fbz5gvks15g">
            Ahorras ${savings}
          </p>
          <p className="mt-3 text-sm text-muted" data-id="element-198" data-mp="2ecc39m8v6ttx">
            {product.currency} · pago único, sin suscripciones
          </p>

          <BuyButton isCheckout className="mt-8 w-full text-center" data-id="element-199" data-mp="36ug0737mao8j">
            {cta.label}
          </BuyButton>
          <p className="mt-3 text-center text-[13px] leading-snug text-muted" data-id="element-200" data-mp="1j6xp5imrqj2a">{cta.sub}</p>

          <div className="mt-7 flex gap-3 border-t border-line pt-6" data-id="element-201" data-mp="1e6s3cj36jqs4">
            <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage" aria-hidden="true" data-id="element-202" data-mp="1e9o2gaqrkli5" />
            <p className="text-sm leading-relaxed text-muted" data-id="element-203" data-mp="19ab68ze0622w">
              <span className="font-semibold text-ink" data-id="element-204" data-mp="14af9nl7mxcxd">Garantía de 7 días.</span> Si sigues el
              protocolo y no notas diferencia, te devolvemos el 100%.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}